<template>
  <IconLucideDownload />
</template>
